// extracted by mini-css-extract-plugin
module.exports = {"container":"Form-module--container--1sb4S","contact":"Form-module--contact--2BELt","inputs":"Form-module--inputs--ANBfq","right":"Form-module--right--YJxTC"};